export class ScuolaTag {
    id!: string;
    testo!: string;
    tagPadreId!: string;
    punteggio!: number; //emoticon
    percentuale!: number;
    ordine?: any; //ordine scuole
    top?: boolean; //diamante
}